import { Stack } from '@startuptools/ui/Stack';
import {
  GqlAgendaItem,
  GqlAgendaItemDecision,
  GqlMeeting,
  GqlMeetingParticipant,
} from '../../../graphql/base-types.graphql';
import { BoardMeetingDocument } from '../../board-meetings/BoardMeeting.graphql';
import { ShareholdersMeetingDocument } from '../../shareholders-meetings/ShareholdersMeeting.graphql';
import { useDeleteAiMutation, useSetAiOrderMutation } from '../../../graphql/react-operations';
import { ProtocolEditItem } from './ProtocolEditItem';
import { AiMcProps } from './agenda-items/MeetingConcern';
import { DisplayIdentity } from '@startuptools/business-ui/identity/Identity';
import { useQueryState } from 'nuqs';

export const MeetingProtocolEdit = ({
  meeting,
  meetingConcerns,
  agendaItems,
  isBoardsRecommendation = false,
  movableRange,
}: {
  meeting: Pick<GqlMeeting, 'id' | 'primaryLang' | 'secondaryLang' | 'companyId' | 'startTime' | 'kind'> & {
    meetingParticipants: (Pick<GqlMeetingParticipant, 'id' | 'present' | 'chairman' | 'secretary' | 'adjuster'> & {
      identity: DisplayIdentity;
      proxy?: DisplayIdentity | null;
    })[];
  };
  meetingConcerns: AiMcProps[];
  agendaItems: Array<
    Pick<
      GqlAgendaItem,
      | 'id'
      | 'subjectPrimaryLang'
      | 'subjectSecondaryLang'
      | 'order'
      | 'done'
      | 'canHaveBoardsRecommendation'
      | 'commentPrimaryLang'
      | 'commentSecondaryLang'
      | 'mandatory'
      | 'kind'
      | 'firstGroup'
      | 'lastGroup'
    > & {
      agendaItemDecisions: Pick<
        GqlAgendaItemDecision,
        'id' | 'order' | 'decisionPrimaryLang' | 'decisionSecondaryLang'
      >[];
    }
  >;
  isBoardsRecommendation?: boolean;
  movableRange: number[];
}) => {
  const [editAiId, setEditAiId] = useQueryState('agenda_item');

  const [doDelete, { loading: deleteLoading }] = useDeleteAiMutation({
    refetchQueries: [BoardMeetingDocument, ShareholdersMeetingDocument],
  });
  const [doMove, { loading: moveLoading }] = useSetAiOrderMutation({
    refetchQueries: [BoardMeetingDocument, ShareholdersMeetingDocument],
  });

  const loading = deleteLoading || moveLoading;
  const isEditingAgendaItem = Boolean(editAiId);

  return (
    <Stack gap={1}>
      {agendaItems.map(ai => {
        return (
          <ProtocolEditItem
            key={ai.id}
            meeting={meeting}
            meetingConcerns={meetingConcerns}
            agendaItems={agendaItems}
            ai={ai}
            isBoardsRecommendation={isBoardsRecommendation}
            movableRange={movableRange}
            editAiId={editAiId}
            setEditAiId={setEditAiId}
            loading={loading}
            isEditingAgendaItem={isEditingAgendaItem}
            doMove={doMove}
            doDelete={doDelete}
          />
        );
      })}
    </Stack>
  );
};
